import { render } from "./PressResults.vue?vue&type=template&id=3c959722"
import script from "./PressResults.vue?vue&type=script&lang=js"
export * from "./PressResults.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Press/PressResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c959722"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c959722', __exports__)) {
    api.reload('3c959722', __exports__)
  }
  
  module.hot.accept("./PressResults.vue?vue&type=template&id=3c959722", () => {
    api.rerender('3c959722', render)
  })

}


export default __exports__